<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 d-flex flex-column h-100">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="108"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <ziro-loading-block [hidden]="displayEditor"></ziro-loading-block>
    <ziro-pstn-call-record-query-editor-field
      class="mb-3"
      [fieldId]="'callRecordQuery'"
      [minDateInString]="oldestCdrRecordDate"
      [disabledDateTooltipText]="
        'tkey;reports.microsoft.pstn_call_record_finder.query.min_date.disabled.tooltip.text'
          | translate: { minDate: getDateFormatted() }
      "
      [tenantId]="tenantId"
      [hidden]="!displayEditor"
    ></ziro-pstn-call-record-query-editor-field>
    @if (displayEditor) {
      <ziro-datatable
        [columns]="tableColumns"
        [rowDataSource]="datatableRows"
        [uniqueRowIdentifier]="'rowId'"
        [mainFilterPlaceholder]="'tkey;reports.microsoft.pstn_call_record_finder.table.search.placeholder' | translate"
        [dataAutomation]="tableDataAutomation"
        [showCustomAlert]="showCustomAlert"
        [noResultsAlert]="'tkey;reports.microsoft.pstn_call_record_finder.table.no_call_records.message' | translate"
        [isPaginated]="true"
        [matchesSecondaryDataFn]="searchSubTextsWithinRow"
        [class]="'ziro-card'"
      >
        <div class="text-center" alert-content>
          {{ 'tkey;reports.microsoft.pstn_call_record_finder.table.cdr_exceeds_limit.message' | translate }}
        </div>
      </ziro-datatable>
    }
  </div>
</div>
<ziro-bottom-nav data-automation="call-records-bottom-nav"></ziro-bottom-nav>
